const PREFIX = 'app.sp.';
const STORAGE_KEY = `${PREFIX}redirect-after-login`;

export default {
  get: (): string | null => localStorage.getItem(STORAGE_KEY),
  set: (value: string): void => localStorage.setItem(STORAGE_KEY, value),
  remove: (): void => localStorage.removeItem(STORAGE_KEY)
};
